import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { ThemeProvider } from "@material-ui/core";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { localUserService } from "utils/localStorage";
import { checkAuthFromStorage } from "actions/authAction";
import { initializeApp } from "actions/initializeActions";
import theme from "./theme";
import Loader from "router/components/Loader";
import Router from "router/Router";
import "./App.css";
import { getNotifications } from "actions/notificationsActions";
import { DRIVER } from "constants/constants";

function App() {
  const dispatch = useDispatch();
  const isInitialize = useRef(false);
  const { isLoginError, isLoginPending, userData } = useTypeSelectors((state) => state.auth);
  const { amazonHistoryLoading } = useTypeSelectors((state) => state.amazonReports);
  const { reportListLoading } = useTypeSelectors((state) => state.dasBoard);
  const { loadingData, dashBoardDateLoading } = useTypeSelectors(
    (state) => state.dashboard,
  );
  const { weightsLoading } = useTypeSelectors((state) => state.weightsData);

  const generalLoading =
    amazonHistoryLoading ||
    isLoginPending ||
    loadingData ||
    dashBoardDateLoading ||
    weightsLoading ||
    reportListLoading;

  const token = localUserService.getAccess();

  useEffect(() => {
    if (token && !isInitialize.current && !isLoginError) {
      dispatch(checkAuthFromStorage());
      dispatch(initializeApp());
      isInitialize.current = true;
    } else {
      isInitialize.current = false;
    }
  }, [token, isLoginError, dispatch]);

  useEffect(() => {
    if (userData.id && userData.role === DRIVER) {
      dispatch(getNotifications(userData.id));
    }
  }, [userData.id, userData.role, dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <Loader isLoading={generalLoading} />
      <Router />
    </ThemeProvider>
  );
}

export default App;
